import * as react from "react";
import { Record, Union } from "./fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, lambda_type, unit_type, list_type, bool_type, union_type } from "./fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Benachrichtigungen_BenachrichtigungsTyp_$reflection, Benachrichtigungen_Benachrichtigung_$reflection } from "../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { empty, filter, length } from "./fable_modules/fable-library-js.4.19.0/List.js";
import { equals } from "./fable_modules/fable-library-js.4.19.0/Util.js";

const defaultCurrentPageContext = void 0;

export const currentPageContext = react.createContext(defaultCurrentPageContext);

export class NotificationFilter extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["All", "Unread"];
    }
}

export function NotificationFilter_$reflection() {
    return union_type("Bfs.Web.Kundenportal.Context.NotificationFilter", [], NotificationFilter, () => [[], []]);
}

export class NotificationContext extends Record {
    constructor(HasUnreadNotifications, NotificationsLoading, ShowNotifications, Notifications, Filter, ChangeFilter, ToggleShowNotifications, MarkAllRead, Navigate) {
        super();
        this.HasUnreadNotifications = HasUnreadNotifications;
        this.NotificationsLoading = NotificationsLoading;
        this.ShowNotifications = ShowNotifications;
        this.Notifications = Notifications;
        this.Filter = Filter;
        this.ChangeFilter = ChangeFilter;
        this.ToggleShowNotifications = ToggleShowNotifications;
        this.MarkAllRead = MarkAllRead;
        this.Navigate = Navigate;
    }
}

export function NotificationContext_$reflection() {
    return record_type("Bfs.Web.Kundenportal.Context.NotificationContext", [], NotificationContext, () => [["HasUnreadNotifications", bool_type], ["NotificationsLoading", bool_type], ["ShowNotifications", bool_type], ["Notifications", list_type(Benachrichtigungen_Benachrichtigung_$reflection())], ["Filter", NotificationFilter_$reflection()], ["ChangeFilter", lambda_type(NotificationFilter_$reflection(), unit_type)], ["ToggleShowNotifications", lambda_type(unit_type, unit_type)], ["MarkAllRead", lambda_type(unit_type, unit_type)], ["Navigate", lambda_type(Benachrichtigungen_BenachrichtigungsTyp_$reflection(), unit_type)]]);
}

export function NotificationContext__get_UnreadCount(this$) {
    return length(filter((_arg) => _arg.IstNeu, this$.Notifications));
}

export function NotificationContext__get_FilteredNotifications(this$) {
    return filter((x) => {
        if (equals(this$.Filter, new NotificationFilter(0, []))) {
            return true;
        }
        else {
            return x.IstNeu;
        }
    }, this$.Notifications);
}

export const defaultNotificationContext = new NotificationContext(false, false, false, empty(), new NotificationFilter(0, []), (_arg) => {
    throw new Error("NotificationContext not initialized");
}, () => {
    throw new Error("NotificationContext not initialized");
}, () => {
    throw new Error("NotificationContext not initialized");
}, (_arg_3) => {
    throw new Error("NotificationContext not initialized");
});

export const currentNotificationContext = react.createContext(defaultNotificationContext);

//# sourceMappingURL=Context.fs.js.map
